import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ColDef } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { AlertService } from '../../alert-panel/alert.service';
import { BaseComponent } from '../../shared/base/base-component';
import { AppGridComponent } from '../../shared/grid/grid-component/grid.component';
import { ApiRequest, CCActionsEnum, GradeStatusEnum, IApiresponse } from '../../_models';
import { Claims } from '../../_models/common/claims';
import { GridConfig } from '../../_models/common/grid/grid-config';
import { GradeMappedEmployeeList, IGradeMappedEmployeeList, IRequestGradeListAll, IResponseGradeList, RequestGradeListAll } from '../../_models/grade/grade';
import { GradeService, ManageempService } from '../../_services';
import { ClaimsService } from '../../_services/common/claims.service';
import { LoggingPanelService } from '../../_services/logging-panel/logging-panel.service';

@Component({
    selector: 'app-assign-grade-panel',
    templateUrl: './assign-grade-panel.component.html',
    standalone: false
})
export class AssignGradePanelComponent extends BaseComponent implements OnInit, OnChanges  {

  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;

    @Output() uncheckEvent = new EventEmitter<any>();
    @Output() closePanel = new EventEmitter<boolean>(); 

    @Input() selectedItems: any[] = [];    
    @Input() panelHeading: string;
    isBulkOperation = false;
    rowKey: string;
    userActionEventSubscription: Subscription;
    claimsSubscription: Subscription;
    claims: Claims;
    currentUser: any;
    columnDefinitions: ColDef[];
    defaultSortColumn;
    gridConfigItems: GridConfig;
    gridColumnDefs: ColDef[];
    gridData: any;

    allApproversList: any = [];
    gradeAllList: any = [];
    assignedGradeId: number = null;    
    selectedGradeId:number = 0;
    hasFormChanges: boolean = false;
    disableAssign: boolean = true;
    disableSave: boolean = true;   
    isSaved: boolean = false;

    panelItemType: number = 0;
    showApproverStatusPanel: boolean = false;
    employeesList: any[] = [];
    selectedItemsText: string;
    anyTextForDisplay: string = '';
    selectedGradeStatus :number=0;
    selectedGradeName:string;
    assignedEmployeeCount:number=0;
    localOrganisationId: any;
    
    constructor(
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private toastr: ToastrService,
        private alertService: AlertService,
        private manageEmpService: ManageempService,
        private gradeService: GradeService,
        private loggingPanelService: LoggingPanelService
    ) {        
        super();
        this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
            this.localOrganisationId = this.claims.OrgId;
        });
        this.userActionEventSubscription = this.alertService.getUserActionEvent().subscribe(action => {
            if (action) {
                this.resetFields();
                this.closePanel.emit(false);
            }
        });
    }

    ngOnInit(): void {
        this.gridData = JSON.parse(JSON.stringify(this.selectedItems));
        this.fnInitialiseEmployeesGrid();
        this.getAllGradeForOrg();
    }

    getAllGradeForOrg() {
      let gradeRequest = new ApiRequest<IRequestGradeListAll>(
        "SoloGetAllGradeByOrgId",
        1.0,
        "111"
      );
      let gradeRequestInfo = new RequestGradeListAll(this.claims.OrgId);
      gradeRequest.requestInfo = gradeRequestInfo;
      this.gradeService
        .GetAllGradeByOrgId(gradeRequest)
        .subscribe((response: IApiresponse<IResponseGradeList>) => {
          this.gradeAllList = [];
          if (response.responseInfo != null) {
            this.gradeAllList = response.responseInfo.gradeList.filter(it=>it.gradeStatus == GradeStatusEnum.Active);
          }          
        });
    }

    fnCreateColumnDefs() {
      this.columnDefinitions = [
        {
          headerName: this.translate.instant('claimant_name'),
          field: 'employeeName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 100,
  
        },
        {
          headerName: this.translate.instant('claimant_email'),
          field: 'employeeEmail',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 100,
  
        },
        {
          headerName: this.translate.instant('policy_grade_name'),
          field: 'gradeName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 100,
  
        },
        {
          headerName: this.translate.instant('label_status'),
          field: 'gradeStatus',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          cellRenderer: 'fieldValueRenderer',
          minWidth: 100,
          headerComponentParams: [
            { class: 'active-color font-weight-bold', value: GradeStatusEnum.Active, text: this.translate.instant("label_active") }
          ]
  
        },
        {
          headerName: "",
          cellRenderer: 'actionRenderer',
          field: 'userActionField',
          suppressMovable: true,
          suppressHeaderMenuButton: true,
          sortable: false,
          minWidth: 100,
          headerComponentParams:
            [
              {
                buttonClass: 'fas fa-edit color-green',
                buttonTooltip: this.translate.instant('label_edit'),
                userAction: CCActionsEnum.Edit
              }
  
            ]
        }
      ];
    }

    ngOnDestroy() {
        this.claimsSubscription.unsubscribe();
        this.userActionEventSubscription.unsubscribe();
    }

    ngOnChanges(changes) {
      this.gridData = JSON.parse(JSON.stringify(this.selectedItems));
    
      if (this.gridComponent) {
          setTimeout(() => {
              this.gridComponent.refreshGridData();
          }, 100);
      }

      let key = '', selectedItemKey = '';
      key = 'assign_grade_selected_claimant';
      selectedItemKey = 'label_selected_grade';
      
      this.selectedItemsText = this.translate.instant(selectedItemKey);

      if (this.selectedItems && this.selectedItems.length > 1) {
          this.panelHeading = `${this.translate.instant('labl_bulk_action')}: ${this.translate.instant('label_selected')} ${this.selectedItems.length}`;
          this.anyTextForDisplay = '';
      }
      else {
          this.panelHeading = this.translate.instant(key);
      }
    }  

    canDeactivate() {
        return !this.hasFormChanges;
    }

    fnGridInit() {
        this.rowKey = "employeeId" ;
        if (this.columnDefinitions && this.columnDefinitions.length > 0) {
            this.gridColumnDefs = JSON.parse(JSON.stringify(this.columnDefinitions));

            this.gridColumnDefs = this.gridColumnDefs.filter(c => c.field != "selected");

            this.gridColumnDefs.splice(this.gridColumnDefs.length - 1, 1,
                {
                    headerName: "",
                    valueGetter: 'data && data.' + this.rowKey,
                    cellRenderer: 'actionRenderer',
                    field: 'userActionField',
                    suppressMovable: true,
                    suppressHeaderMenuButton: true,
                    sortable: false,
                    minWidth: 100,
                    headerComponentParams:
                        [
                            {
                                buttonClass: 'fas fa-minus-circle color-red',
                                buttonTooltip: this.translate.instant('remove_text'),
                                userAction: 1
                            }
                        ]
                });

            this.defaultSortColumn = this.gridColumnDefs[0].field;
        }


        this.gridConfigItems = new GridConfig(
            true,
            true,
            this.defaultSortColumn,
            this.rowKey,
            0,
            false,
            [],
            true,
            true,
            false,
            null,
            'asc',
            40,
            'no_data_availabe',
            null,
            null,
            false, false,
      '',
      '',
      false
        );
    }

    fnInitialiseEmployeesGrid() {
        this.fnCreateColumnDefs();
        this.fnGridInit();
        setTimeout(() => {
            this.gridComponent.initializeGrid();
        }, 100);
    }   

    onGradeChange() {     
        if (this.assignedGradeId) {
            this.disableAssign = false;
            this.selectedGradeId = this.assignedGradeId;
            const selectedGrade = this.gradeAllList.find(a => a.gradeId == this.selectedGradeId);
            if (selectedGrade) {            
                this.selectedGradeName = selectedGrade.gradeName;
                this.selectedGradeStatus = selectedGrade.gradeStatus;
                this.assignedEmployeeCount = parseInt(selectedGrade.assignedEmployeeCount);                              
            }
            else {
              this.selectedGradeName = '';
              this.selectedGradeStatus = 0;
              this.assignedEmployeeCount = 0;               
            }
        }        
    }

    fnOnGridCellClick(params) {
      if (params.column.colId === 'userActionField') {
        if(params.data.userAction == 1) {
                this.uncheckEvent.emit(params.data);                                      
        }
    }      
    }    

    fnClosePanel() {
        if (this.canDeactivate()) {
            this.resetFields();
            this.closePanel.emit(this.isSaved);
            this.isSaved = false;
        }
        else {
            this.alertService.onFormClosed();
        }
    }

    assignGrade() {
        if (this.selectedGradeId) {            
              this.disableSave = false;
              this.disableAssign = true;
              this.hasFormChanges = true;             
              this.assignGradeToClaimants();
              if (this.gridComponent) {
                  setTimeout(() => {
                      this.gridComponent.refreshGridData();
                  }, 100);
              } 
              this.resetSelectedGrade();           
        }        
    }

    assignGradeToClaimants() {
        this.gridData.forEach((item) => {
            item.gradeId = this.selectedGradeId;
            item.gradeName = this.selectedGradeName;
            item.gradeStatus = this.selectedGradeStatus;
        });        
    }

    fnGetGradeName(gradeId:number){
      let grade = "";
      if(this.gradeAllList && gradeId){
       let gradeDetails =  this.gradeAllList.find(c=>c.gradeId == gradeId);
        if(gradeDetails){
          grade = gradeDetails.costCentreName;
        }
      }
      return grade;
    }

    

    assignGradeToEmployee() {
        let gradeRequest = new ApiRequest<IGradeMappedEmployeeList>(
          "SoloAssignDeassignGradeToEmployee",
          1.0,
          "111"
        );
    
        var employeesIds: number[] = [];
    
        this.gridData.forEach(item => {
          employeesIds.push(item.employeeId);
        });
    
        let gradeMappedEmployeeListModel = new GradeMappedEmployeeList(
          this.selectedGradeId,
          this.localOrganisationId,
          employeesIds
        );
    
        gradeRequest.requestInfo = gradeMappedEmployeeListModel;
        if(employeesIds.length>10)
        {
          this.gradeService
            .AssignDeassignGradeToEmployeeBackground(gradeRequest)
            .pipe(first())
            .subscribe((response: any) => {
              if (response.statusCode == 200) {
                this.toastr.info(this.translate.instant("JobSubmittedToaster"));              
                this.isBulkOperation = false;
                this.hasFormChanges=false;
                this.closePanel.emit(true);
              }
            });
        }
        else
        {
            this.gradeService
            .AssignDeassignGradeToEmployee(gradeRequest)
            .pipe(first())
            .subscribe((response: any) => {
              if (response.statusCode == 200) {
                this.toastr.success(this.translate.instant("success"));
                this.getAllGradeForOrg();             
                this.isBulkOperation = false;
                this.hasFormChanges=false;
                this.closePanel.emit(true);
              }
            });
        }
      }     
    

    saveAssignments() {
        this.disableAssign = true;
        this.disableSave = true;
        this.toastr.info(this.translate.instant("request_processing_info"));        
    }    

    resetFields() {      
        this.resetSelectedGrade();  
        this.hasFormChanges = false;
        this.disableAssign = true;
        this.disableSave = true;        
    }    

    
    resetSelectedGrade() {
      this.selectedGradeName=null;
      this.selectedGradeStatus=null;
      this.assignedEmployeeCount = 0;  
      this.assignedGradeId = null;
    }  


}


